import { render, staticRenderFns } from "./DMCustomerService.vue?vue&type=template&id=24fffae8&scoped=true&"
import script from "./DMCustomerService.vue?vue&type=script&lang=js&"
export * from "./DMCustomerService.vue?vue&type=script&lang=js&"
import style0 from "./DMCustomerService.vue?vue&type=style&index=0&id=24fffae8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fffae8",
  null
  
)

export default component.exports